import jwt_decode from 'jwt-decode';
import { UserStore } from '@/store/modules/user';
interface IAbc {
  (): void
  'cancel': () => void | undefined
}
const randomElement = (arr = []) => {
  return arr[Math.floor(Math.random() * arr.length)];
};
const kebab = (str: string) => {
  return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

const clearAllSearchPage = (RouteName: String) => {
  // 清空其他页面的page
  Object.keys(localStorage).forEach((item, index) => {
    if (item !== 'auth_token') {
      if (item.indexOf('_page') > 0 && item !== `${getModuleName(RouteName as string)}_page`) {
        localStorage.removeItem(item);
      }
      if (item.indexOf('_search') > 0 && item !== `${getModuleName(RouteName as string)}_search`) {
        localStorage.removeItem(item);
      }
    }
  });
}
const clearPage = (RouteName: String) => {
  // 清空其他页面的page
  Object.keys(localStorage).forEach((item, index) => {
    if (item !== 'auth_token') {
      if (item.indexOf('_page') > 0 && item !== `${getModuleName(RouteName as string)}_page`) {
        localStorage.removeItem(item);
      }
    }
  });
}
/**全屏 */
const toggleFullScreen = () => {
  let doc = <any>window.document;
  let docEl = <any>doc.documentElement;

  let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    requestFullScreen.call(docEl);
  } else {
    cancelFullScreen.call(doc);
  }
};
// 
const formatCurrencyPrice = function (num: any) {
  if (!num || isNaN(num)) {
    num = "0.00";
  }
  num = num.toString().replace(/\$|\,/g, '');
  let sign = (num == (num = Math.abs(num)));
  num = Math.floor(num * 100 + 0.50000000001);
  let cents: any = num % 100;
  num = Math.floor(num / 100).toString(); if (cents < 10)
    cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
    num = num.substring(0, num.length - (4 * i + 3)) + ',' + num.substring(num.length - (4 * i + 3));
  }
  return (((sign) ? '' : '-') + num + '.' + cents);
}
const formatCurrency = function (num: any) {
  if (num !== 0 && !num) {
    return;
  }
  num = num.toString().replace(/\$|\,/g, "");
  if (isNaN(num)) num = "0";
  let sign = num == (num = Math.abs(num));
  num = Math.floor(num * 100 + 0.50000000001);
  let cents: any = num % 100;
  num = Math.floor(num / 100).toString();
  if (cents < 10) cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
    num =
      num.substring(0, num.length - (4 * i + 3)) +
      "," +
      num.substring(num.length - (4 * i + 3));
  return (sign ? "" : "-") + num + (cents == "00" ? "" : "." + cents);
};
/**格式化时间 2018/09/30*/
const formatDateTime = (date: any) => {
  if (!date) return;
  var d = date instanceof Date ? date : new Date(Date.parse(date.replace(/-/g, "/"))),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hour = "" + d.getHours(),
    minute = "" + d.getMinutes();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (hour.length < 2) hour = "0" + hour;
  if (minute.length < 2) minute = "0" + minute;

  return [year, month, day].join("/") + " " + [hour, minute].join(":");
}
/**格式化时间 根据传入的格式 */
const formatDateByFormat = (dateStr: any, fmt: string) => {
  const date = new Date(dateStr)
  var o: { [key: string]: any } = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  return fmt;
}
/**jwt_decode token */
const jwtParse = function (token: string) {
  try {
    let decode = jwt_decode(token)
    return decode
  } catch (error) {
    return ""
  }
}
const NumfixedTwo = function (x: any) {
  var f = parseFloat(x);
  var f = Math.round(x * 100) / 100;
  var s = f.toString();
  var rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }

  return s;
}

const isPermission = function (permissionName: string): boolean {
  if (!permissionName) {
    return false;
  }
  if (UserStore.permissions.indexOf(permissionName) >= 0) {
    return true;
  }
  return false;
}
export const getModuleName = function (moduleName: string) {
  if (moduleName && moduleName.indexOf('_') >= 0) {
    return moduleName.substring(0, moduleName.lastIndexOf("_"));
  } else {
    return moduleName
  }
};
export const getModuleIndex = function (moduleName: string) {
  if (moduleName && moduleName.indexOf('_') >= 0) {
    return moduleName.substring(0, moduleName.indexOf("_"));
  } else {
    return moduleName
  }
};
export const stausRenderDiableColor = function (status: any) {
  // console.log(status)
  switch (status) {
    case false:
    case "StopSale":
    case "Cancel":
    case "Canceled":
    case "Ban":
      return { style: { color: '#999999'} }
    default:
      return {}
  }
}
export const stausDiableColor = function (status: any) {
  // console.log(status)
  // console.log(12321312)
  switch (status) {
    case false:
    case "StopSale":
    case "Cancel":
    case "Canceled":
    case "Ban":
      return '#999999'
    default:
      return ''
  }
}
export const throttle = function (func: any, wait: any, options: any) {
  var timeout: any, context: any, args: any, result: any

  // 上一次执行回调的时间戳
  var previous = 0
  // 无传入参数时，初始化 options 为空对象
  if (!options) options = {}
  var later = function () {
    // 当设置 { leading: false } 时
    // 每次触发回调函数后设置 previous 为 0
    // 不然为当前时间
    previous = options.leading === false ? 0 : +new Date()
    // 防止内存泄漏，置为 null 便于后面根据 !timeout 设置新的 timeout
    timeout = null
    // 执行函数
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }

  // 每次触发事件回调都执行这个函数
  // 函数内判断是否执行 func
  // func 才是我们业务层代码想要执行的函数
  var throttled = <IAbc>function () {
    // 记录当前时间
    var now = +new Date()

    // 第一次执行时（此时 previous 为 0，之后为上一次时间戳）
    // 并且设置了 { leading: false }（表示第一次回调不执行）
    // 此时设置 previous 为当前值，表示刚执行过，本次就不执行了
    if (!previous && options.leading === false) previous = now

    // 距离下次触发 func 还需要等待的时间
    var remaining = wait - (now - previous);
    (window as any).globalThis = window;
    context = globalThis
    args = arguments

    // 要么是到了间隔时间了，随即触发方法（remaining <= 0）
    // 要么是没有传入 {leading: false}，且第一次触发回调，即立即触发
    // 此时 previous 为 0，wait - (now - previous) 也满足 <= 0
    // 之后便会把 previous 值迅速置为 now
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)

        // clearTimeout(timeout) 并不会把 timeout 设为 null
        // 手动设置，便于后续判断
        timeout = null
      }

      // 设置 previous 为当前时间
      previous = now

      // 执行 func 函数
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      // 最后一次需要触发的情况
      // 如果已经存在一个定时器，则不会进入该 if 分支
      // 如果 {trailing: false}，即最后一次不需要触发了，也不会进入这个分支
      // 间隔 remaining milliseconds 后触发 later 方法
      timeout = setTimeout(later, remaining)
    }
    return result
  }

  // 手动取消
  throttled.cancel = () => {
    clearTimeout(timeout)
    previous = 0
    timeout = context = args = null
  }

  return throttled
}

export default {
  randomElement,
  toggleFullScreen,
  kebab,
  formatDateTime,
  formatDateByFormat,
  jwtParse,
  formatCurrency,
  formatCurrencyPrice,
  isPermission,
  NumfixedTwo,
  stausRenderDiableColor,
  stausDiableColor,
  clearAllSearchPage,
  clearPage
};


